import { DataBaseModelInterface } from '@solcre-org/core';
import { VesselFuelModel } from './vessel-fuel.model';

export class VesselModel implements DataBaseModelInterface {
  public vesselFuels: VesselFuelModel[] = [];

  constructor(
    public id?: any,
    public vesselName?: string,
    public imoNumber?: string,
    public typeOfVessel?: string,
    public status?: string,
    public totalSquareMeters?: string,
    public totalLaneMeters?: string,
    public totalCapacityVehicles?: number,
    public totalCapacityTons?: string,
    public vesselCostPerDay?: string,
    public mafiCapacity?: number,
    public airDraft?: string,
    public rampType: string[] = [],
    public createdAt?: string,
    public loa?: string,
    public beam?: string,
    public grt?: string,
    public nrt?: string,
    public dwt?: string
  ) { }

  public fromJSON(json: any): VesselModel {
    if (json) {
      this.id = json.id;
      this.vesselName = json.vesselName;
      this.imoNumber = json.imoNumber;
      this.typeOfVessel = json.typeOfVessel;
      this.status = json.status;
      this.totalSquareMeters = json.totalSquareMeters?.toString() ?? '';
      this.totalLaneMeters = json.totalLaneMeters?.toString() ?? '';
      this.totalCapacityVehicles = json.totalCapacityVehicles;
      this.totalCapacityTons = json.totalCapacityTons?.toString() ?? '';
      this.vesselCostPerDay = json.vesselCostPerDay?.toString() ?? '';
      this.mafiCapacity = json.mafiCapacity;
      this.airDraft = json.airDraft?.toString() ?? '';
      this.rampType = Array.isArray(json.rampType) ? json.rampType : (json.rampType ? [json.rampType] : []);
      this.createdAt = json.createdAt;
      this.loa = json.loa?.toString() ?? '';
      this.beam = json.beam?.toString() ?? '';
      this.grt = json.grt?.toString() ?? '';
      this.nrt = json.nrt?.toString() ?? '';
      this.dwt = json.dwt?.toString() ?? '';

      // Parse vessel fuels if included in response
      if (Array.isArray(json.vesselFuels)) {
        this.vesselFuels = new VesselFuelModel().fromJSONList(json.vesselFuels);
      }
    }
    return this;
  }

  public fromJSONList(json: any): VesselModel[] {
    if (json) {
      return json.map((element: any) => new VesselModel().fromJSON(element));
    }
    return [];
  }

  public toJSON() {
    return {
      id: this.id,
      vesselName: this.vesselName,
      imoNumber: this.imoNumber,
      typeOfVessel: this.typeOfVessel,
      status: this.status,
      totalSquareMeters: this.totalSquareMeters?.toString() ?? '',
      totalLaneMeters: this.totalLaneMeters?.toString() ?? '',
      totalCapacityVehicles: this.totalCapacityVehicles,
      totalCapacityTons: this.totalCapacityTons,
      vesselCostPerDay: this.vesselCostPerDay,
      mafiCapacity: this.mafiCapacity,
      airDraft: this.airDraft,
      rampType: this.rampType,
      createdAt: this.createdAt,
      loa: this.loa,
      beam: this.beam,
      grt: this.grt,
      nrt: this.nrt,
      dwt: this.dwt,
    };
  }

  public getId() {
    return this.id?.toString() ?? '';
  }

  public getReference() {
    return this.vesselName ?? '';
  }
}
